module.exports = __webpack_public_path__ + "img/popular-cities.caac5f85.png";